<template>
  <transition name="modal">
    <div class="modal modal-class">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="header-text">
              header-text
            </slot>
            <button class="close" type="button" @click="close_modal()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <slot name="modal-body"></slot>
          <div class="modal-footer">
            <slot name="modal_buttons"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    close_modal () {
      this.$parent.close_modal()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Modal.vue